// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// No static translation bundles are shipped anymore: all UI text VALUES come exclusively from the
// runtime store, fetched from the backend at runtime (see app/locale/i18nBundle.ts →
// /api/i18n/texts). The namespaces below start empty and are populated by loadLanguageBundle().
i18n.use(LanguageDetector)
    //.use(HttpBackend)
    .use(initReactI18next)
    .init({
        // debug: true,
        // backend: {
        //     loadPath: "/locales/{{lng}}/{{ns}}.json",
        // },
        resources: {
            en: {
                translation: {}
            },
            de: {
                translation: {}
            }
        },
        lng: "de",
        // No silent German fallback: a missing/empty runtime text shows the key itself instead.
        fallbackLng: false,
        returnEmptyString: false,
        // detection: {
        //     order: ["localStorage"],
        //     caches: ["localStorage"],
        // },
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
